export const getLabelClass = (label) => {
  switch (label) {
    case 'Next Investment Window: December':
      return 'NextInvestmentWindow';
    case 'Nearly Funded':
      return 'NearlyFunded';
    case 'Closing Soon':
      return 'ClosingSoon';
    case '25% Funded':
      return 'Funded25';
    case '50% Funded':
      return 'Funded50';
    case '75% Funded':
      return 'Funded75';
    case '90% Funded':
      return 'Funded90';
    case 'Closed':
      return 'Closed';
    case 'New':
      return 'New';
    case 'Coming Soon':
      return 'ComingSoon';
    case 'Funded':
      return 'Funded';
    case 'Fully Funded':
      return 'FullyFunded';
    default:
      return '';
  }
};
